import { createFileRoute } from '@tanstack/react-router'
import { ArticleEdit } from '@/features/articles/pages/article-edit'

export const Route = createFileRoute('/_authenticated/articles/$articleId/edit')({
  component: RouteComponent,
})

function RouteComponent() {
  const { articleId } = Route.useParams()
  
  return <ArticleEdit articleId={articleId} />
}
